import {
  Warehouse,
  PackageCheck,
  ShoppingCart,
  FileCheck,
  ArrowRightLeft,
  Users,
  Grid3x3,
  Settings,
  BarChart3,
  ShoppingBag,
  Database,
  Cloud,
  AlertCircle,
  CheckCircle,
  Info,
  Zap,
  TrendingUp,
  Package,
  FileText,
  Home,
  Menu,
  Bell,
  Search,
  Filter,
  Download,
  Upload,
  Eye,
  Edit,
  Trash2,
  Plus,
  Minus,
  X,
  Check,
  Smartphone,
  Bot,
  type LucideIcon,
} from 'lucide-react';

const iconMap = {
  warehouse: Warehouse,
  receiving: PackageCheck,
  procurement: ShoppingCart,
  invoices: FileCheck,
  transfers: ArrowRightLeft,
  staff: Users,
  apps: Grid3x3,
  settings: Settings,
  analytics: BarChart3,
  pos: ShoppingBag,
  erp: Database,
  mydata: Cloud,
  alert: AlertCircle,
  success: CheckCircle,
  info: Info,
  zap: Zap,
  trending: TrendingUp,
  package: Package,
  document: FileText,
  home: Home,
  menu: Menu,
  bell: Bell,
  search: Search,
  filter: Filter,
  download: Download,
  upload: Upload,
  eye: Eye,
  edit: Edit,
  trash: Trash2,
  plus: Plus,
  minus: Minus,
  close: X,
  check: Check,
  phone: Smartphone,
  automation: Bot,
  inventory: Package,
  waste: Trash2,
  prep: FileText,
  tasks: CheckCircle,
  ocr: Eye,
} as const;

export type AppIconName = keyof typeof iconMap;

interface AppIconProps {
  name: AppIconName;
  className?: string;
  size?: number | 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

export function AppIcon({ name, className = '', size = 'md' }: AppIconProps) {
  const IconComponent: LucideIcon = iconMap[name];
  const sizeValue = typeof size === 'number' ? size : sizeMap[size];

  return (
    <IconComponent
      className={className}
      size={sizeValue}
      strokeWidth={2}
    />
  );
}
